import { setUnreadReplies } from '../mutators/mutators';
import getConversationItems from '../services/getConversationItems';
import getStore from '../store';
import type ItemId from 'owa-service/lib/contract/ItemId';
import isFeatureEnabled from 'owa-feature-flags/lib/utils/isFeatureEnabled';
import { logSpacesDatapoint } from 'owa-timestream-logging';

export function getUnreadReplies(conversationId: ItemId) {
    const existingUnreadReplies = getStore().unreadReplies;

    if (isFeatureEnabled('outlookSpaces-mailThread') && conversationId) {
        // we don't want to be unnecessarily calling GCI if we've already done so that session
        if (existingUnreadReplies.has(conversationId.Id)) {
            return existingUnreadReplies.get(conversationId.Id);
        }

        updateUnreadReplies(conversationId);
    }
    return null;
}

export function updateUnreadReplies(conversationId: ItemId) {
    getConversationItems(conversationId)
        .then(nodes => {
            if (!!nodes) {
                setUnreadReplies(conversationId, nodes);
            }
        })
        .catch(e => {
            logSpacesDatapoint('OUTLOOKSPACES_GET_CONVERSATION_ITEM_FAILED', {
                conversationId: conversationId.Id,
                error: e.message,
            });
        });
}
